import { z } from 'zod'
import { ASSET_LABEL_MAX_LENGTH, generatedAssetSchema } from './ai-studio-asset'

const hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Expected #rrggbb hex color')

/** Credit cost of one QR code generation. */
export const QR_CREDIT_COST = 20

export const qrErrorCorrectionSchema = z.enum(['L', 'M', 'Q', 'H'])

export type QrErrorCorrection = z.infer<typeof qrErrorCorrectionSchema>

export const generateQrRequestSchema = z.object({
  data: z.string().min(1).max(1024),
  foreground: hexColor.default('#000000'),
  background: hexColor.default('#ffffff'),
  size: z.number().int().min(256).max(2048).default(1024),
  margin: z.number().int().min(0).max(8).default(2),
  errorCorrectionLevel: qrErrorCorrectionSchema.default('M'),
  /** Names the entity the code belongs to; used for the stored asset title. */
  label: z.string().max(ASSET_LABEL_MAX_LENGTH).optional(),
})

export type GenerateQrRequest = z.infer<typeof generateQrRequestSchema>

export const generateQrResponseSchema = z.object({
  asset: generatedAssetSchema,
})

export type GenerateQrResponse = z.infer<typeof generateQrResponseSchema>
